<template>
  <Layout class="g-wrapper g-vertical-block">
    <div class="c-document g-main-wrapper">
      <!-- filter -->
      <baidu-filter :account-data="accountData" @on-change="filterData" @add-set="addSet" />
      <!-- table -->
      <div class="c-table-list">
        <Viewport v-model="tableHeight">
          <baidu-table
            :height="tableHeight"
            :loading="loading"
            :data="tableList"
            :columns="tableCol"
            @on-edit="addSet"
            @on-del="delSet"
            @on-refresh="getData"
          />
          <Page
            show-total
            show-sizer
            show-elevator
            :total="total"
            :current.sync="pageIndex"
            :page-size="pageSize"
            :page-size-opts="[10, 20, 30, 40, 100]"
            @on-change="changePageIndex"
            @on-page-size-change="changePageSize"
            class="c-table-page pager"
            size="small"
          />
        </Viewport>
      </div>

      <!-- 弹出框 -->
      <baidu-set
        v-model="model"
        title="小游戏配置"
        :account-data="accountData"
        :info="info"
        :edit="edit"
        :loading="loading"
        @on-save="saveSet"
      />
    </div>
  </Layout>
</template>
<script>
import mixin from '../mixins/mixin'
import columns from '../data/baiduset_column'
import { setLocal, getLocal } from '@/common/js/api'
import { isArray } from '@/common/js/utils'
import { queryConfigByCondytion, getLogidUrl, delLogidUrl, insertOrUpdate } from '@/api/manage.model'
import { adAccount } from '@/api/common.model'
import BaiduFilter from './components/baidu-filter'
import BaiduTable from './components/baidu-table'
import BaiduSet from './components/baidu-set'

export default {
  name: 'baiduData',
  mixins: [mixin],
  components: { BaiduFilter, BaiduTable, BaiduSet },

  methods: {
    getData(filter) {
      let params = {
        pageIndex: this.pageIndex,
        pageSize: this.pageSize
      }
      if (filter) params = Object.assign(params, filter)
      else params = Object.assign(this.params, params)
      this.params = JSON.parse(JSON.stringify(params))
      // 加载状态
      this.loading = true
      queryConfigByCondytion(params)
        .then((data) => {
          this.loading = false
          if (!data) return
          const { list, page_info } = data
          if (isArray(list) && page_info) {
            const { total_number } = page_info
            this.total = total_number || 0
            this.tableList = list.map((ret) => {
              return ret
            })
          }
        })
        .catch((err) => {
          this.$Message.error({
            duration: 5,
            content: err
          })
        })
    },
    setLocalPage(size) {
      setLocal('BAIDUSET_PAGESIZE', size)
    },
    delSet(row) {
      const { adAccountId, gameId } = row
      delLogidUrl({
        adAccountId,
        gameId
      }).then((data) => {
        if (data) {
          this.$Message.success('删除成功！')
          this.getData()
        }
      })
    },
    addSet(edit) {
      this.edit = !!edit
      if (edit) {
        const { adAccountId, gameId, id } = edit
        this.loading = true
        getLogidUrl({ adAccountId, gameId }).then((data) => {
          this.loading = false
          if (data) {
            const { logidUrl, gameId, adAccountId, token } = data
            this.info = { logidUrl, gameId, adAccountId, token, media: 'baidu', id }
            this.model = true
          } else {
            this.$Message.warning('未查询到配置信息')
          }
        })
      } else {
        this.info = { logidUrl: '', media: 'baidu', adAccountId: '', gameId: '' }
        this.model = true
      }
    },
    saveSet(params) {
      const { id, logidUrl, gameId, adAccountId, token } = params
      if (id) {
        this.loading = true
        insertOrUpdate({ id, logidUrl, gameId, adAccountId, token }).then((data) => {
          this.loading = false
          if (data) {
            this.$Message.success('添加配置成功！')
            this.getData()
          }
        })
      } else {
        this.loading = true
        insertOrUpdate({ logidUrl, gameId, adAccountId, token }).then((data) => {
          this.loading = false
          if (data) {
            this.$Message.success('添加配置成功！')
            this.getData()
          }
        })
      }
      this.model = false
    },
    proloadData() {
      Promise.all([adAccount({ authFlag: 1, mediaId: 45 })])
        .then((data) => {
          const [accountData] = data
          isArray(accountData) && (this.accountData = accountData)
        })
        .catch((err) => {
          console.log(err)
        })
    }
  },
  data() {
    return {
      tableHeight: 330,
      model: false, // 弹窗开关
      saving: false, // 设置状态
      edit: null,
      groupList: [],
      accountData: [],
      info: {}
    }
  },
  created() {
    this.pageSize = parseInt(getLocal('BAIDUSET_PAGESIZE')) || 20
    this.tableCol = columns
    this.proloadData()
  }
}
</script>
<style lang="scss" scoped>
.c-document {
  width: 100%;
  height: 100%;
  padding: 8px 8px 0;
}

.c-table-page {
  padding: 5px 0;
  text-align: right;
}
</style>
